import React from 'react';
import GenericSetupPage from './GenericSetupPage';

const ARAdjustmentReasonPage = () => {
  const columns = [
    { key: 'code', label: 'Code' },
    { key: 'reason', label: 'Reason' },
    { key: 'description', label: 'Description' },
    { key: 'active', label: 'Active' },
  ];

  const formFields = [
    { key: 'code', label: 'Code', type: 'text', required: true },
    { key: 'reason', label: 'Reason', type: 'text', required: true },
    { key: 'description', label: 'Description', type: 'textarea', required: false, fullWidth: true },
    { key: 'active', label: 'Active', type: 'select', required: true, options: [
      { value: 'Yes', label: 'Yes' },
      { value: 'No', label: 'No' }
    ]}
  ];

  const initialData = [
    { id: '1', code: 'WO', reason: 'Write Off', description: 'Bad debt write off', active: 'Yes' },
    { id: '2', code: 'CO', reason: 'Contractual Obligation', description: 'Contractual adjustment per payer agreement', active: 'Yes' },
    { id: '3', code: 'PR', reason: 'Patient Responsibility', description: 'Patient deductible/copay', active: 'Yes' },
    { id: '4', code: 'OA', reason: 'Other Adjustment', description: 'Miscellaneous adjustment', active: 'Yes' },
    { id: '5', code: 'TF', reason: 'Timely Filing', description: 'Claim denied due to timely filing', active: 'Yes' },
  ];

  return (
    <GenericSetupPage
      title="A/R Adjustment Reason"
      columns={columns}
      initialData={initialData}
      addButtonText="Add Reason"
      formFields={formFields}
      apiEndpoint="/setup/ar-adjustment-reason"
    />
  );
};

export default ARAdjustmentReasonPage;
